import { pick as lo_pick } from 'es-toolkit';
import { isObject as lo_isObject } from 'es-toolkit/compat';
import { isString as lo_isString } from 'es-toolkit';
import { get as lo_get } from 'es-toolkit/compat';

import {
    bulkOrderFormModel,
    type BulkOrderFormModel,
} from '~/models';
import type {
    BulkOrderItem,
    SalesTransaction
} from '~/types';


export function useBulkOrderUtils() {

    function unWrapUid(obj: unknown, prop: string, idProp: string = 'uid'): Nullable<string> {
        if (lo_isObject(obj) && lo_isString(obj[prop as keyof typeof obj])) {
            return obj[prop as keyof typeof obj] ?? null;
        }

        return lo_get(obj, [prop, idProp], null) ?? null
    }

    function salesOrderToBulkOrderModel(
        orderObj: BulkOrderItem | BulkOrderFormModel | Partial<SalesTransaction>,
        keys?: string[]
    ): BulkOrderFormModel {
        orderObj = Object.assign({}, orderObj);

        if ('billToAddress' in orderObj) {
            orderObj.billToAddress = unWrapUid(orderObj, 'billToAddress');
        }

        if ('shipToAddress' in orderObj) {
            orderObj.shipToAddress = unWrapUid(orderObj, 'shipToAddress');
        }

        if ('shippingService' in orderObj) {
            orderObj.shippingService = unWrapUid(orderObj, 'shippingService');
        }

        // TODO: Fix type
        // @ts-ignore
        return lo_pick(orderObj, keys || Object.keys(bulkOrderFormModel.entries)) as BulkOrderFormModel;
    }

    return {
        salesOrderToBulkOrderModel
    };
}
